<template>
    <v-form class="text-center py-5 px-5">
        <v-row>
            <v-col cols="6">
                <v-text-field
                    autofocus
                    aria-required
                    required
                    v-validate="'required|name'"
                    validate-on-blur
                    :error-messages="errors.first('name')"
                    type="text"
                    label="First name"
                    outlined
                ></v-text-field>
            </v-col>

            <v-col cols="6">
                <v-text-field
                    autofocus
                    aria-required
                    required
                    v-validate="'required|name'"
                    validate-on-blur
                    :error-messages="errors.first('name')"
                    type="text"
                    label="Last name"
                    outlined
                ></v-text-field>
            </v-col>
        </v-row>

        <v-textarea
          label="Street Address"
          auto-grow
          outlined
          rows="1"
          row-height="15"
        ></v-textarea>


        <v-row>
            <v-col cols="6">
                <v-text-field
                    autofocus
                    aria-required
                    required
                    v-validate="'required|phone'"
                    validate-on-blur
                    :error-messages="errors.first('phone')"
                    type="text"
                    label="Beneficiary's Phone number"
                    outlined
                ></v-text-field>
            </v-col>

            <v-col cols="6">
                <v-select
                    flat
                    :items="countries"
                    hide-details
                    outlined
                    color="grey darken-4"
                    item-color="primary"
                    item-text="country"
                    item-value="abbreviation"
                    label="Country"
                    return-object
                    class="selection--teal"
                >
                </v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <v-select
                    flat
                    :items="cities"
                    hide-details
                    outlined
                    color="grey darken-4"
                    item-color="primary"
                    item-text="country"
                    item-value="abbreviation"
                    label="Beneficiary's State of Residence"
                    return-object
                    class="selection--teal"
                >
                </v-select>
            </v-col>

            <v-col cols="6">
                <v-text-field
                    autofocus
                    aria-required
                    required
                    v-validate="'required|address'"
                    validate-on-blur
                    :error-messages="errors.first('town')"
                    type="text"
                    label="Town/City"
                    outlined
                ></v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import cities from './states.json';

export default {
    data: () => ({
        countries: [],
        cities,
    }),
    mounted() {
        const vm = this;
        function loadCountries() {
            Vue.backendApi()
                .countries()
                .list()
                .then(success, error);

            function success(response) {
                Vue.set(vm, 'countries', response.data);
            }

            function error(err) {
                vm.$swal({
                    type: 'error',
                    title: 'Error loading countries',
                    text: err,
                });
            }
        }

        loadCountries();
    }
}
</script>

<style>

</style>